import { formatTimestampHuman, formatDateHuman, formatCurrency } from "../date-utils";
export const companyInvoiceEmailsDtoFields = [{
        name: "dataEvento",
        title: "Data Evento",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.email.createdOn)
    }, {
        name: "sendEmail",
        title: "Esito",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            if (record.email.risultato == "OK")
                return `<span class="icon"><i class="material-icons icon-base has-text-success">check</i></span>`;
            if (record.email.risultato == "ACCODATO")
                return `<span class="icon"><i class="material-icons icon-base has-text-primary">access_time</i></span>`;
            else
                return `<span class="icon"><i class="material-icons icon-base has-text-danger">warning</i></span>`;
        }
    }, {
        name: "diagnostico",
        title: "Diagnostico",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            if (record.email.risultato == "OK")
                return ``;
            else
                return record.email.diagnostico;
        }
    }, {
        name: "cliente",
        title: "Cliente",
        render: (record) => record.ragionesociale
    }, {
        name: "email",
        title: "Email",
        render: (record) => record.emailDestinatario
    }, {
        name: "numeroFattura",
        title: "N° fattura",
        render: (record) => record.invoice.numeroFattura
    }, {
        name: "ownership",
        title: "Az. proprietaria",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.ownership.name
    }, {
        name: "importo",
        title: "Importo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatCurrency(record.invoice.importo) //new Intl.NumberFormat('it-IT', {style: 'currency',currency: 'EUR',minimumFractionDigits: 2,maximumFractionDigits: 2})
        //.format(record.invoice.importo)
    }, {
        name: "dataEmissione",
        title: "Data Emissione",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.invoice.dataEmissione)
    }];
